import { WheelCampaign } from "../models/wheel-campaign";
import { httpClient } from "../http-clients/http-client";

export async function getActiveWheelCampaign(): Promise<WheelCampaign> {
    const response = await httpClient.get<WheelCampaign>("/api/kasa/wheel-campaign");

    return response.data;
}
